import { DefectType } from "../../models/defectType";
import { CheckDetectorMappingData } from "./checkDetectorDefectMapping.controller";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import * as _ from "lodash";
import template from './editCheckDetectorDefectMapping.tpl.html';
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import CheckDetectorDefectMappingServiceName, { CheckDetectorDefectMappingService }
  from "../../services/checkDetectorDefectMapping/checkDetectorDefectMapping.service";

let requires = [NotifyServiceName, CheckDetectorDefectMappingServiceName];

export interface EditCheckDetectorDefectMappingController {
  checkDetectorText: string;
  defectTypeId: string;
  defectType: DefectType;
  defectTypes: DefectType[];
  mode: string;
  submit(): void;
  cancel(): void;
}

export function openEditCheckDetectorDefectMapping(data: CheckDetectorMappingData, $modal: mm.foundation.modal) {
  let modalInstance = $modal.open({
    template: template,
    controller: 'EditCheckDetectorDefectMappingCtrl as vm',
    resolve: {
      data: () => data
    }
  });
  return modalInstance.result;
}

class EditCheckDetectorDefectMappingCtrl implements EditCheckDetectorDefectMappingController {
  checkDetectorText: string;
  defectTypeId: string;
  defectType: DefectType;
  defectTypes: DefectType[];
  mode: string;
  form: angular.IFormController;
  readOnly: boolean;
  private $q: angular.IQService;
  private notifyService: NotifyService;
  private checkDetectorDefectMappingService: CheckDetectorDefectMappingService;
  private $modalInstance: mm.foundation.modalInstance;
  private $modal: mm.foundation.modal;

  constructor(
    notifyService: NotifyService,
    checkDetectorDefectMappingService: CheckDetectorDefectMappingService,
    $q: angular.IQService,
    data: CheckDetectorMappingData,
    $modalInstance: mm.foundation.modalInstance,
    $modal: mm.foundation.modal) {
    this.$modalInstance = $modalInstance;
    this.$modal = $modal;
    this.notifyService = notifyService;
    this.checkDetectorDefectMappingService = checkDetectorDefectMappingService;
    this.$q = $q;
    this.defectTypes = _.sortBy(data.defectTypes, 'name');
    this.checkDetectorText = data.checkDetectorText;
    this.defectType = data.defectType;
    this.mode = data.checkDetectorText.length > 0 ? 'Update' : 'Add';
    this.readOnly = data.checkDetectorText.length > 0;
  }

  submit(): void {
    if (this.form.$invalid) {
      return;
    }
    let mapping: apsViewModels.CheckDetectorDefectMappingItem = {
      checkDetectorText: this.checkDetectorText,
      defectTypeId: this.defectType.id,
      defectTypeName: this.defectType.name
    };
    let submit: angular.IPromise<any> = this.mode === 'Add'
      ? this.checkDetectorDefectMappingService.addCheckDetectorDefectMapping(mapping)
      : this.checkDetectorDefectMappingService.updateCheckDetectorDefectMapping(mapping);
    submit.then(() => this.$modalInstance.close(mapping),
      this.notifyService.handleApiErrors);
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.editCheckDetectorDefectMapping', requires)
  .controller('EditCheckDetectorDefectMappingCtrl', EditCheckDetectorDefectMappingCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkDetectorDefectMappings/editCheckDetectorDefectMapping.controller.ts